import React from 'react';
import { createRoot } from 'react-dom/client';
import HomeImpactCalculator from '../src/calculators/HomeImpactCalculator';
import SavingsCalculator from '../src/calculators/SavingsCalculator';
import NewsletterBanner from '../src/components/newsletterBanner/NewsletterBanner';

import '../stylesheets/custom.scss';
import 'bootstrap/scss/bootstrap-utilities.scss';

const HOME_IMPACT_CALC_ID = 'home-impact-container';
const SAVINGS_CALC_ID = 'savings-calculator-container';
const NEWSLETTER_BANNER_ID = 'newsletter-banner-container';

/**
 * js pack that adds all necessary savings and impact calculators to a page
 * checks for presence of properly named div, and inserts the calculator there
 */
document.addEventListener('DOMContentLoaded', () => {
  const homeImpactContainer = document.getElementById(HOME_IMPACT_CALC_ID);
  if (homeImpactContainer) {
    const container = homeImpactContainer.appendChild(document.createElement('div'))
    const root = createRoot(container)

    root.render(<HomeImpactCalculator />);
  }

  const savingsCalcContainer = document.getElementById(SAVINGS_CALC_ID);
  if (savingsCalcContainer) {
    const container = savingsCalcContainer.appendChild(document.createElement('div'))
    const root = createRoot(container)

    root.render(<SavingsCalculator />);
  }

  const newsletterBannerContainer = document.getElementById(NEWSLETTER_BANNER_ID);
  if (newsletterBannerContainer) {
    const container = newsletterBannerContainer.appendChild(document.createElement('div'))
    const root = createRoot(container)

    root.render(<NewsletterBanner />);
  }
});
